import { render, staticRenderFns } from "./CreatureCompetition.vue?vue&type=template&id=5412f2b2&scoped=true&"
import script from "./CreatureCompetition.vue?vue&type=script&lang=js&"
export * from "./CreatureCompetition.vue?vue&type=script&lang=js&"
import style0 from "./CreatureCompetition.vue?vue&type=style&index=0&id=5412f2b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412f2b2",
  null
  
)

export default component.exports